import React, { useCallback, useState } from "react";
import { Button, Tag } from "antd";
import {
  ArrowLeftOutlined,
  CloseOutlined,
  ExportOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { SceneIframe } from "../RutasEvaluationList/SceneIframe";
import styles from "./SceneViewer.module.scss";

/**
 * SceneViewer — visor de escena lanzada (Itinerarios, F4).
 * Barra superior (volver, titulo, categoria, test activo, abrir-en-ventana,
 * cerrar) + el iframe del juego (reutiliza SceneIframe).
 */
export function SceneViewer({
  scene,
  shortLink,
  fallbackUrl,
  accessToken,
  routeId,
  activeQuizName,
  onClose,
}) {
  const { t } = useTranslation("evaluations");
  const [resolvedUrl, setResolvedUrl] = useState("");

  const handleResolved = useCallback((url) => setResolvedUrl(url || ""), []);

  const openNew = () => {
    if (resolvedUrl) window.open(resolvedUrl, "_blank", "noopener,noreferrer");
  };

  const cats = Array.isArray(scene?.category)
    ? scene.category.filter(Boolean)
    : [];

  return (
    <div className={styles.viewer}>
      <div className={styles.toolbar}>
        <Button
          type="text"
          icon={<ArrowLeftOutlined />}
          onClick={onClose}
          className={styles.back}
        />
        <div className={styles.titleWrap}>
          <span className={styles.title} title={scene?.title}>
            {scene?.title || "—"}
          </span>
          {cats.map((c) => (
            <Tag key={c} className={styles.cat}>
              {c}
            </Tag>
          ))}
          {activeQuizName ? (
            <Tag className={styles.testTag}>
              {t("itinerarios.activeTest")}: {activeQuizName}
            </Tag>
          ) : null}
        </div>
        <div className={styles.actions}>
          <Button
            icon={<ExportOutlined />}
            disabled={!resolvedUrl}
            onClick={openNew}
          >
            {t("sceneIframe.openNewWindow")}
          </Button>
          <Button type="text" icon={<CloseOutlined />} onClick={onClose} />
        </div>
      </div>

      <div className={styles.stage}>
        <SceneIframe
          accessToken={accessToken}
          shortLink={shortLink}
          fallbackUrl={fallbackUrl}
          routeId={routeId}
          scene={scene}
          onResolvedUrl={handleResolved}
        />
      </div>
    </div>
  );
}

export default SceneViewer;
